<template>
  <div class="tab-list" ref="tabContainer">
    <div
      :class="['home-tab-item', currentTab?.name === homeItem.name ? 'is-active' : '']"
      @click="handleHomeTab"
    >
      <span>{{ $t(homeItem.localKey) || homeItem.name }}</span>
      <!-- <i class="el-icon-close" @click.stop="handleClose(item, index)"></i> -->
      <el-icon style="margin-left: 10px" @click.stop="handleClose(item, index)"><House /></el-icon>
    </div>
    <div
      v-for="(item, index) in menuList"
      :key="item.name"
      :class="['tab-item', currentTab?.name === item.name ? 'is-active' : '']"
      @click="handleChangeTab(item)"
      @contextmenu.prevent="rightClick($event, { item, index })"
      draggable="true"
      @dragstart="onDragStartHandler(index)"
      @dragover.prevent
      @drop="onDropHandler(index)"
    >
      <span :title="$t(item.localKey) || item.name">{{ $t(item.localKey) || item.name }}</span>
      <!-- <i class="el-icon-close" @click.stop="handleClose(item, index)"></i> -->
      <el-icon style="margin-left: 10px" @click.stop="handleClose(item, index)"><Close /></el-icon>
    </div>
    <el-popover
      placement="bottom-start"
      :show-arrow="false"
      :offset="1"
      popper-class="hide-menu-popover"
      v-model:visible="hideMenuVisible"
      v-if="allMenuList.length > tabNum1"
      :width="180"
    >
      <ul>
        <li
          v-for="item in hideMenuList"
          :key="item.name"
          :class="['hide-menu-item', currentTab.name === item.name ? 'is-active' : '']"
          :title="$t(item.localKey) || item.name"
          @click="handleChangeTab(item)"
        >
          {{ $t(item.localKey) || item.name }}
        </li>
      </ul>
      <template #reference>
        <div class="tab-more">
          <!-- <i class="el-icon-more"></i> -->
          <el-icon><MoreFilled /></el-icon>
        </div>
      </template>
    </el-popover>
  </div>
  <div v-show="isRightClick" ref="rightClickMenu" class="tab-right-click-list">
    <div style="margin-left: 20px; border-left: 1px solid #cccccc">
      <div class="list-item" style="border-bottom: 1px solid #cccccc" @click="refresh">
        {{ $t('main_header_refresh') }}
      </div>
      <div class="list-item" @click="handleClose(rightClickItem.item, rightClickItem.index)">
        {{ $t('main_header_close') }}
      </div>
      <div class="list-item" @click="handleAllClose">{{ $t('main_header_close_all') }}</div>
      <div
        class="list-item"
        style="border-bottom: 1px solid #cccccc"
        @click="handleCloseExceptThis(rightClickItem.item)"
      >
        {{ $t('main_header_close_addition') }}
      </div>
      <div class="list-item" @click="handleCloseRight(rightClickItem.item, rightClickItem.index)">
        {{ $t('main_header_close_right') }}
      </div>
      <div class="list-item" @click="handleCloseLeft(rightClickItem.item, rightClickItem.index)">
        {{ $t('main_header_close_left') }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted, onUnmounted, reactive, watch } from 'vue'
import { Close, House, MoreFilled } from '@element-plus/icons-vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
// import { onDragStart, onDrop } from 'vue-demi' // 导入拖拽事件处理函数
import { $t } from '@/lang'
export default defineComponent({
  name: 'ContainerTabList',
  components: {
    Close,
    House,
    MoreFilled
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    const homeItem = ref({
      name: $t('main_home_home_name'),
      routeUrl: '/'
    })

    const tabContainer = ref(null)
    // const state = reactive({
    //   visibleTabs: [],
    //   hiddenTabs: [],
    //   dropdownVisible: false
    // })

    const tabNum1 = ref(7)

    onMounted(() => {
      calculateVisibleTabs()
        window.addEventListener('resize', calculateVisibleTabs)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', calculateVisibleTabs)
    })

    const allMenuList = computed(() => {
      return store.state.menu.tabList
    })

    // console.log(allMenuList)
    // data
    const currentTab = computed(() => {
      return store.state.menu.currentTab
    })
    const menuList = computed(() => {
      return allMenuList.value.slice(0, tabNum1.value)
    })
    const hideMenuList = computed(() => {
      return allMenuList.value.slice(tabNum1.value)
    })

    // 处理拖拽开始事件
    const onDragStartHandler = index => {
      draggingIndex.value = index // 将当前拖拽的标签页索引保存到变量中
    }

    // 处理放置拖拽元素事件
    const onDropHandler = index => {
      console.log('s', menuList.value)
      event.preventDefault() // 阻止默认事件，如打开链接
      const draggedIndex = draggingIndex.value // 获取拖拽的标签页索引
      store.commit('menu/changeTabMenu', { draggedIndex, index })
    }

    const draggingIndex = ref(null) // 保存当前拖拽的标签页索引

    const calculateVisibleTabs = () => {
      if (tabContainer.value) {
        // 获取容器的宽度
        const containerWidth = tabContainer.value.offsetWidth
        // 计算可见标签页的数量
        tabNum1.value = Math.floor(containerWidth / 140)
      }
    }

    const hideMenuVisible = ref(false)
    const handleChangeTab = (tabItem, isHomeTab) => {
      hideMenuVisible.value = false
      store.commit('menu/changeCurrentTab', tabItem)
      router.push(tabItem.routeUrl)
      // history.pushState(null, null, tabItem.route)
    }
    const handleHomeTab = () => {
      hideMenuVisible.value = false
      store.commit('menu/setCurrentTab', homeItem.value)
      router.push(homeItem.value.routeUrl)
    }
    const handleClose = (item, index) => {
      // 如果标签页列表只有一个标签页
      if (allMenuList.value.length === 1) {
        handleHomeTab() // 切换到主页标签页
        // history.pushState(null, null, '/')
      } else if (currentTab.value.name === item.name) {
        let nextTabIndex = index + 1
        // 如果当前标签页是最后一个标签页，则切换到前一个标签页
        if (nextTabIndex === allMenuList.value.length) nextTabIndex = index - 1
        const nextTab = allMenuList.value[nextTabIndex]
        store.commit('menu/changeCurrentTab', nextTab) // 切换当前标签页
        router.push(nextTab.routeUrl) // 跳转到下一个标签页的路由
        // history.pushState(null, null, nextTab.route)
      }
      store.commit('menu/deleteTab', item.name) // 删除标签页
    }

    const isRightClick = ref(false)
    const rightClickMenu = ref(null)
    const rightClickItem = ref(null)
    // 处理右键点击事件
    const rightClick = (data, tabItem) => {
      isRightClick.value = false // 重置右键点击状态为false
      isRightClick.value = true // 设置右键点击状态为true
      const { clientX, clientY } = data // 获取鼠标点击位置的坐标
      rightClickItem.value = tabItem // 设置右键点击的标签页项
      rightClickMenu.value.style.left = `${clientX - 70}px` // 设置右键菜单的水平位置
      rightClickMenu.value.style.top = `${clientY + 20}px` // 设置右键菜单的垂直位置
      document.addEventListener('click', cancleRightClickMenu) // 监听点击事件，用于取消右键菜单
    }

    const cancleRightClickMenu = () => {
      isRightClick.value = false
      document.removeEventListener('click', cancleRightClickMenu)
    }

    const refresh = () => {
      location.reload()
    }

    const handleAllClose = () => {
      store.commit('menu/resetTab')
      handleHomeTab()
    }

    const setCurrentTab = item => {
      if (currentTab.value.name !== item.name) {
        store.commit('menu/changeCurrentTab', item)
        router.push(item.routeUrl)
      }
    }

    const handleCloseExceptThis = item => {
      store.commit('menu/setTab', [item])
      setCurrentTab(item)
    }

    const handleCloseRight = (item, index) => {
      const beforeTab = allMenuList.value.slice(0, index + 1)
      store.commit('menu/setTab', beforeTab)
      setCurrentTab(item)
    }

    const handleCloseLeft = (item, index) => {
      const afterTab = allMenuList.value.slice(index)
      store.commit('menu/setTab', afterTab)
      setCurrentTab(item)
    }

    return {
      tabContainer,
      homeItem,
      handleHomeTab,
      tabNum1,
      currentTab,
      menuList,
      allMenuList,
      hideMenuList,
      hideMenuVisible,
      rightClickMenu,
      isRightClick,
      rightClickItem,
      handleChangeTab,
      handleClose,
      rightClick,
      refresh,
      handleAllClose,
      handleCloseExceptThis,
      handleCloseRight,
      handleCloseLeft,
      onDropHandler,
      onDragStartHandler
    }
  }
})
</script>

<style lang="scss" scoped>
.tab-list {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  .home-tab-item {
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-right: $border-grey;
    cursor: pointer;
    font-size: 12px;
    span {
      white-space: nowrap;
    }
    & + .tab-item {
      border-left: none;
    }
    &:hover {
      color: $primary-color;
    }
    &.is-active {
      color: $primary-color;
      font-weight: bold;
      background-color: #ffffff;
    }
  }
  .tab-item {
    @extend .home-tab-item;
    overflow: hidden;
    .el-icon-close {
      margin-left: 10px;
    }
    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .tab-more {
    flex-shrink: 0;
    width: 42px;
    height: 100%;
    border-right: $border-grey;
    text-align: center;
    line-height: 42px;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.tab-right-click-list {
  position: absolute;
  background-color: #ffffff;
  width: 160px;
  left: 0;
  top: 0;
  list-style: none;
  margin: 0;
  box-sizing: border-box;
  box-shadow: 0 0 4px rgba(200, 200, 200, 0.5);
  border-radius: 5px;
  margin-top: 0 !important;
  z-index: 9999;

  .list-item {
    font-size: 12px;
    padding: 5px 0;
    color: #303133;
    padding-left: 10px;
    box-sizing: border-box;

    &:hover {
      cursor: pointer;
      background-color: #eeeeee;
    }
  }
}
</style>
